import { render, staticRenderFns } from "./SocietyContactForm.vue?vue&type=template&id=21bcac48&scoped=true"
import script from "./SocietyContactForm.vue?vue&type=script&lang=js"
export * from "./SocietyContactForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21bcac48",
  null
  
)

export default component.exports